export const gameCategories = [
  {
    slug: 'jingdian',
    name: '经典老虎机',
    description: '体验经典水果机与复古老虎机玩法，简单刺激回味无穷',
    icon: 'ri-gamepad-line',
    count: 42,
  },
  {
    slug: 'dongman',
    name: '动漫主题',
    description: '热门动漫IP授权游戏，与你喜爱的角色一起冒险',
    icon: 'ri-film-line',
    count: 28,
  },
  {
    slug: 'shenhua',
    name: '神话传说',
    description: '东西方神话故事改编，沉浸式剧情与丰厚奖励',
    icon: 'ri-vip-crown-line',
    count: 35,
  },
  {
    slug: 'maoxian',
    name: '冒险探索',
    description: '跟随主线剧情探索未知世界，解锁隐藏关卡与宝藏',
    icon: 'ri-compass-3-line',
    count: 31,
  },
  {
    slug: 'dongwu',
    name: '动物世界',
    description: '可爱动物主题游戏，轻松休闲适合全年龄段玩家',
    icon: 'ri-emotion-laugh-line',
    count: 24,
  },
  {
    slug: 'shuiguo',
    name: '水果乐园',
    description: '色彩缤纷的水果主题，清新明快的游戏体验',
    icon: 'ri-leaf-line',
    count: 19,
  },
  {
    slug: 'sangong',
    name: '棋牌竞技',
    description: '经典棋牌游戏模拟，策略与运气并重的智力对决',
    icon: 'ri-gamepad-line',
    count: 26,
  },
  {
    slug: 'tiyu',
    name: '体育赛事',
    description: '体育主题模拟游戏，感受赛场激情与竞技魅力',
    icon: 'ri-football-line',
    count: 15,
  },
];

export const allGames = [
  {
    id: 'g1',
    name: '宝石传奇',
    category: 'jingdian',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20gemstones%20and%20crystals%20scattered%20on%20a%20dark%20velvet%20background%2C%20luxurious%20casino%20aesthetic%20with%20sparkling%20jewels%2C%20golden%20accents%2C%20warm%20ambient%20lighting%2C%20rich%20color%20contrast%2C%20elegant%20composition&width=600&height=400&seq=game-gem-legend&orientation=landscape',
    rating: 4.9,
    players: '128,500',
    isHot: true,
    isNew: false,
  },
  {
    id: 'g2',
    name: '忍者传说',
    category: 'dongman',
    image: 'https://readdy.ai/api/search-image?query=Silhouette%20of%20a%20ninja%20warrior%20in%20moonlit%20Japanese%20temple%20courtyard%2C%20cherry%20blossom%20petals%20floating%2C%20dramatic%20red%20and%20black%20color%20scheme%2C%20mysterious%20atmosphere%2C%20anime%20inspired%20art%20style&width=600&height=400&seq=game-ninja-legend&orientation=landscape',
    rating: 4.8,
    players: '96,200',
    isHot: true,
    isNew: false,
  },
  {
    id: 'g3',
    name: '宙斯之怒',
    category: 'shenhua',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Greek%20temple%20on%20Mount%20Olympus%20with%20lightning%20bolts%20striking%2C%20golden%20statues%20of%20gods%2C%20dramatic%20storm%20clouds%2C%20epic%20mythological%20scene%2C%20warm%20golden%20and%20electric%20blue%20lighting&width=600&height=400&seq=game-zeus-wrath&orientation=landscape',
    rating: 4.9,
    players: '156,800',
    isHot: true,
    isNew: true,
  },
  {
    id: 'g4',
    name: '丛林探险',
    category: 'maoxian',
    image: 'https://readdy.ai/api/search-image?query=Lush%20tropical%20jungle%20with%20ancient%20stone%20ruins%20hidden%20among%20vines%2C%20rays%20of%20sunlight%20breaking%20through%20canopy%2C%20golden%20treasure%20chest%20glowing%2C%20vibrant%20green%20foliage%2C%20adventure%20atmosphere&width=600&height=400&seq=game-jungle-quest&orientation=landscape',
    rating: 4.7,
    players: '87,300',
    isHot: false,
    isNew: false,
  },
  {
    id: 'g5',
    name: '熊猫乐园',
    category: 'dongwu',
    image: 'https://readdy.ai/api/search-image?query=Cute%20giant%20pandas%20playing%20in%20a%20bamboo%20forest%20with%20colorful%20lanterns%20hanging%2C%20Chinese%20traditional%20garden%20elements%2C%20soft%20warm%20sunlight%2C%20playful%20and%20peaceful%20atmosphere%2C%20bright%20colors&width=600&height=400&seq=game-panda-paradise&orientation=landscape',
    rating: 4.8,
    players: '112,400',
    isHot: true,
    isNew: false,
  },
  {
    id: 'g6',
    name: '水果派对',
    category: 'shuiguo',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20assortment%20of%20juicy%20tropical%20fruits%20on%20a%20sunny%20beach%20setting%2C%20watermelon%20pineapple%20mango%20arranged%20playfully%2C%20bright%20summer%20colors%2C%20festive%20party%20decorations%2C%20refreshing%20atmosphere&width=600&height=400&seq=game-fruit-party&orientation=landscape',
    rating: 4.6,
    players: '73,900',
    isHot: false,
    isNew: false,
  },
  {
    id: 'g7',
    name: '龙之宝藏',
    category: 'shenhua',
    image: 'https://readdy.ai/api/search-image?query=Majestic%20Chinese%20dragon%20coiled%20around%20a%20mountain%20of%20gold%20coins%20and%20jewels%2C%20traditional%20temple%20background%2C%20red%20and%20gold%20color%20palette%2C%20mystical%20glowing%20atmosphere%2C%20epic%20fantasy%20art&width=600&height=400&seq=game-dragon-treasure&orientation=landscape',
    rating: 4.9,
    players: '189,200',
    isHot: true,
    isNew: true,
  },
  {
    id: 'g8',
    name: '德州扑克王',
    category: 'sangong',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20poker%20table%20with%20playing%20cards%20and%20chips%20spread%20out%2C%20warm%20green%20felt%20surface%2C%20golden%20decorative%20elements%2C%20luxurious%20casino%20ambiance%2C%20soft%20overhead%20lighting%2C%20classic%20composition&width=600&height=400&seq=game-texas-poker&orientation=landscape',
    rating: 4.7,
    players: '95,600',
    isHot: false,
    isNew: false,
  },
  {
    id: 'g9',
    name: '足球巨星',
    category: 'tiyu',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20football%20soccer%20stadium%20scene%20with%20spotlights%20illuminating%20the%20pitch%2C%20stadium%20crowd%20silhouettes%2C%20dramatic%20sports%20atmosphere%2C%20green%20field%20with%20white%20lines%2C%20energetic%20composition&width=600&height=400&seq=game-football-star&orientation=landscape',
    rating: 4.5,
    players: '58,200',
    isHot: false,
    isNew: true,
  },
  {
    id: 'g10',
    name: '幸运777',
    category: 'jingdian',
    image: 'https://readdy.ai/api/search-image?query=Classic%20slot%20machine%20with%20three%20sevens%20aligned%2C%20retro%20casino%20vibe%20with%20neon%20lights%2C%20golden%20coins%20spilling%20out%2C%20vintage%20gambling%20aesthetic%2C%20warm%20red%20and%20gold%20color%20scheme%2C%20exciting%20winning%20moment&width=600&height=400&seq=game-lucky-777&orientation=landscape',
    rating: 4.8,
    players: '201,300',
    isHot: true,
    isNew: false,
  },
  {
    id: 'g11',
    name: '埃及秘境',
    category: 'maoxian',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Egyptian%20pyramid%20interior%20with%20hieroglyphics%20on%20walls%2C%20golden%20sarcophagus%20in%20center%2C%20torch%20light%20casting%20warm%20shadows%2C%20mysterious%20treasure%20chamber%2C%20sand%20colored%20palette%20with%20gold%20accents&width=600&height=400&seq=game-egypt-mystery&orientation=landscape',
    rating: 4.7,
    players: '78,400',
    isHot: false,
    isNew: false,
  },
  {
    id: 'g12',
    name: '樱花物语',
    category: 'dongman',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Japanese%20garden%20with%20cherry%20blossom%20trees%20in%20full%20bloom%2C%20traditional%20wooden%20bridge%20over%20koi%20pond%2C%20soft%20pink%20petals%20floating%2C%20peaceful%20spring%20atmosphere%2C%20anime%20art%20style%2C%20dreamy%20lighting&width=600&height=400&seq=game-sakura-tale&orientation=landscape',
    rating: 4.8,
    players: '67,100',
    isHot: false,
    isNew: true,
  },
];